export default __webpack_public_path__ + "static/media/1.aa880b95.jpeg";